import { Address } from '@/models';

export class SiteInfo {
  constructor(
    public sponsorId: number = 0,
    public sponsorNumber: string = '',
    public siteId: number = 0,
    public siteNumber: string = '',
    public siteName: string = '',
    public address: Address | undefined = undefined) {
  }
}
